module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/spec-offer-with-label-b5e5fe09d78f987380583e3786a8ddb2.webp";